module.exports = __webpack_public_path__ + "static/media/LogoExitFundMobile.4b4d16a0.svg";